<h4 class="section-title bg-default mrgn-btm">Dates</h4>
@if (eyeglassPrescription) {
	<div>
		<div class="row mb-3" [attr.data-test-id]="'startDateFormGroup'">
			<label class="col-md-5 col-form-label padding-x-0">Start Date</label>
			<div class="col-md-7">
				<p class="margin-0">{{ eyeglassPrescription.startDate | date:dateFormat }}</p>
			</div>
		</div>
		<div class="row mb-3" [attr.data-test-id]="'endDateFormGroup'">
			<label class="col-md-5 col-form-label padding-x-0">End Date</label>
			<div class="col-md-7">
				<p class="margin-0">{{ eyeglassPrescription.stopDate | date:dateFormat }}</p>
			</div>
		</div>
		<div class="row mb-3" [attr.data-test-id]="'expirationDateFormGroup'">
			<label class="col-md-5 col-form-label padding-x-0">Expiration Date</label>
			<div class="col-md-7">
				<p class="margin-0">{{ eyeglassPrescription.expirationDate | date:dateFormat }}</p>
			</div>
		</div>
	</div>
} @else {
	No Data
}
